<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-caret-square-down"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Type"><FormSelect :options="descriptorLookupOptions" v-model="item.type" field="type" /></FormRow>
      <FormRow label="Description"><FormInputText placeholder="Description" v-model="item.description" field="description" /></FormRow>

      <FormRow label="Address Value" v-show="showAddressLookupValue">
        <FormInputAddressSearch placeholder="Value" v-model="item.value" field="value" :splitAddressComponents="false" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import { DescriptorLookupTypes, DescriptorLookupTypeLookup } from '@/store/types'

export default {
  name: "DescriptorLookupEditDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      id: null,
      item: {},
      dialogForm: {},
      submitting: false,

      descriptorLookupOptions: DescriptorLookupTypeLookup
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Lookup' : 'Edit Lookup'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    showAddressLookupValue() {
      return this.item.type == DescriptorLookupTypes.addressLookup
    },
    displayLookupValue() {
      return this.showAddressLookupValue
    }
  },
  watch: {
  },
  methods: {
    show(item) {
      // Reset form
      this.item = {
        id: 0,
        type: '',
        name: '',
        value: ''
      }
      this.id = 0
      this.dialogForm = {}
      this.submitting = false

      if(item != null) {
        this.item = _.cloneDeep(item)
        this.id = item.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.item)
      if(!this.displayLookupValue)
        updateData.value = ''

      if(this.isCreateMode) {
        this.$apiService.adminService.createDescriptorLookup(updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.adminService.updateDescriptorLookup(this.id, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>